<script lang="ts" setup>
  import HostErrorMessage from './HostErrorMessage.vue';
</script>

<template>
  <HostErrorMessage title="Unauthorized">
    <p>Your Spotify account is not registered as a host.</p>
    <ol>
      <li>Contact Alexander to request access</li>
      <li>Wait for confirmation that your account has been added</li>
      <li>Sign in again</li>
    </ol>
  </HostErrorMessage>
</template>
